import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild } from '@angular/router';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(private authService: AuthService, private router:  Router) {

  }
  canActivate() {
    var auth = this.authService.getAuth();
    if (auth.isAuthorized() && !auth.isAdmin()){
        return true;
    } else {
      if (!auth.isAuthorized()) {
        this.router.navigate(['login']);
      } else {
        this.router.navigate([auth.isAuthorized() && auth.isManager() ? 'admin/approval' : (auth.isAdmin() ? 'admin' : 'dashboard')]);
      }
      return false;
    }
  }

  canActivateChild() {
    var auth = this.authService.getAuth();
    if (auth.isAuthorized() && !auth.isAdmin()){
        return true;
    } else {
      if (!auth.isAuthorized()) {
        this.router.navigate(['login']);
      } else {
        this.router.navigate([auth.isAuthorized() && auth.isManager() ? 'admin/approval' : (auth.isAdmin() ? 'admin' : 'dashboard')]);
      }
      return false;
    }
  }

}


// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/login/auth-guard.service.ts